export const profile = {
  Verified: 'Développeur vérifié',
  'Experience years': "7 ans d'expérience",
  'Minutes on spotify': '83 194 minutes sur Spotify (2024)',
  'About me': 'À propos de moi',
  'About me description': `🚀 Ingénieur Logiciel Senior 🚀

👨‍💻 Ingénieur Logiciel Senior avec 7 ans d'expérience dans le développement d'applications web et mobiles.

📍 Basé à Buenos Aires, Argentine.

💼 Actuellement spécialisé dans les projets Typescript, couvrant à la fois le développement frontend (React.js) et backend (Node.js), avec de l'expérience en développement mobile (React Native / Ionic / Expo). De plus, j'ai travaillé avec d'autres langages de programmation tels que Python et PHP.

⚙️ Passionné par l'automatisation et l'amélioration continue, j'ai également eu l'opportunité de travailler sur des tâches DevOps, optimisant les processus et assurant l'efficacité dans le cycle de vie du développement logiciel.

🔍 Toujours à la recherche de nouveaux défis et opportunités pour appliquer mes compétences techniques et ma passion pour la technologie dans des environnements dynamiques et collaboratifs.
    `,
  'Download CV': 'Télécharger le CV',
};
